/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backgrid from 'backgrid';

import tmplDeliveryScheduleImportStatusCell from './DeliveryScheduleImportStatusCell.hbs';

const DeliveryScheduleImportStatusCell = Backgrid.Cell.extend({
  className: 'delivery-schedule-import-status-cell renderable',

  events: {
    'click .view-link': 'onViewLinkClicked',
    'click .hide-link': 'onHideLinkClicked'
  },

  render() {
    const { status, errors = [] } = this.model.toJSON();

    const showErrors = this.showErrors ?? errors.length === 1;
    const showLinks = errors.length > 1;

    const renderedErrors = errors.map(error => {
      const locationString = this.getLocationString(error.rowNumber, error.columnNumber);
      if (locationString) {
        return `${locationString} ${error.description}`;
      }

      return error.description;
    });

    this.$el.empty().append(tmplDeliveryScheduleImportStatusCell({
      status,
      errors: renderedErrors,
      showErrors,
      showLinks
    }));

    return this;
  },

  onViewLinkClicked() {
    this.showErrors = true;
    this.render();
  },

  onHideLinkClicked() {
    this.showErrors = false;
    this.render();
  },

  getLocationString(row, col) {
    if (col != null) {
      const colString = this.getColumnString(col);

      if (row != null) {
        return `Error in cell ${colString}${Number(row) + 1}:`;
      } else {
        return `Error in column ${colString}:`;
      }
    }

    if (row != null) {
      return `Error in row ${Number(row) + 1}:`;
    }

    return '';
  },

  getColumnString(index) {
    let columnString = '';

    while(index >= 0) {
      const nextLetterIndex = index % 26;
      const nextLetter = String.fromCharCode(nextLetterIndex + 65);

      columnString = nextLetter + columnString;
      index = Math.floor(index / 26) - 1;
    }

    return columnString;
  }
});

export default DeliveryScheduleImportStatusCell;
